<template>
  <v-dialog v-model="completeTicketDialog" content-class="completeTicketDialog">
    <v-card class="">
      <v-card-title class="body-2 maincolor-bg justify-center">
        <img src="@/assets/point/icon_pointcomplete.svg">
        <p class="display-2 text-center font-weight-bold pa-0 ma-0" style="width:100%;">POINT</p>
        <p class="display-2 text-center font-weight-bold pa-0 ma-0" style="width:100%;">COMPLETE</p>
        <p class="subtitle-2 text-center pa-0 mb-3 mt-1" style="width:100%;">ポイントコンプリート</p>
      </v-card-title>
      <p class="subtitle-1 text-center font-weight-bold pa-0 my-0 mt-6" style="width:100%;">おめでとうございます！</p>
      <p class="subtitle-1 text-center font-weight-bold pa-0 my-0" style="width:100%;">コンプリートチケットが</p>
      <p class="subtitle-1 text-center font-weight-bold pa-0 my-0 mb-6" style="width:100%;">プレゼントされました</p>
      <div class="text-center mb-7">
        <v-btn
          rounded
          class="maincolor-bg title"
          x-large
          @click.stop="getTicket()"
        >チケットを確認する</v-btn>
      </div>
      <div class="text-center pb-13">
        <v-btn rounded class="graybtn default_button" depressed @click.stop="close()">あとで確認する</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props:['tabs'],
  data: () => ({
    completeTicketDialog: false,
  }),
  methods: {
    open() {
      this.completeTicketDialog = true;
    },
    close() {
      this.completeTicketDialog = false;
    },
    getTicket() {
      this.completeTicketDialog = false;
      this.$emit("getTicketTab");
    }
  }
}
</script>

<style scope>
.completeTicketDialog {
  overflow-y: visible !important;
}
</style>
